import React, { Component } from 'react';

import './Slide.css';

import Menu from './Menu';

class Slide extends Component {
  render() {
    const {
      sections,
      slideNumber,
      language,
      autoplayVideos,
      isFirstSlide,
      isLastSlide,
    } = this.props; // eslint-disable-line
    const { video, photo, position } = this.props.slide;
    const title =
      this.props.slide[language] && this.props.slide[language].title;
    const description =
      this.props.slide[language] && this.props.slide[language].description;

    const content =
      title || description ? (
        <div className="bottom">
          <div className="content">
            {title && <span className="title">{title}</span>}
            {title && description && ' – '}
            {description}
          </div>
        </div>
      ) : null;

    const leftLink = (
      <div
        className="middle-left"
        onClick={() => {
          Reveal.left(); // eslint-disable-line
        }}
      >
        ‹
      </div>
    );

    const rightLink = (
      <div
        className="middle-right"
        onClick={() => {
          Reveal.right(); // eslint-disable-line
        }}
      >
        ›
      </div>
    );

    if (video && autoplayVideos) {
      const videoURL = require(`../media/videos/${video}`);

      return (
        <section
          data-background-video={videoURL}
          data-background-video-loop
          data-background-video-muted
          className="carsin-slide"
        >
          <Menu currentSlide={slideNumber} sections={sections} />
          {!isFirstSlide && leftLink}
          {!isLastSlide ? rightLink : undefined}
          {content}
        </section>
      );
    }

    const photoURL = require(`../media/photos/${photo}`);

    return (
      <section
        data-background-image={photoURL}
        data-background-position={position || 'center'}
        className="carsin-slide"
      >
        <Menu currentSlide={slideNumber} sections={sections} />
        {!isFirstSlide ? leftLink : undefined}
        {!isLastSlide ? rightLink : undefined}
        {video ? (
          <video
            loop
            onClick={e => {
              e.target.play();
            }}
            className="inline-video"
          >
            <source
              data-src={require(`../media/videos/${video}`)}
              type="video/mp4"
            />
          </video>
        ) : (
          undefined
        )}
        {content}
      </section>
    );
  }
}

Slide.propTypes = {
  slide: React.PropTypes.shape({
    photo: React.PropTypes.string.isRequired,
    video: React.PropTypes.string,
    position: React.PropTypes.string,
    fin: React.PropTypes.shape({
      title: React.PropTypes.string,
      description: React.PropTypes.string,
    }),
    eng: React.PropTypes.shape({
      title: React.PropTypes.string,
      description: React.PropTypes.string,
    }),
  }).isRequired,
  slideNumber: React.PropTypes.number.isRequired,
  sections: React.PropTypes.array.isRequired,
  language: React.PropTypes.string.isRequired,
  isFirstSlide: React.PropTypes.bool,
  isLastSlide: React.PropTypes.bool,
  autoplayVideos: React.PropTypes.bool,
};

export default Slide;



/** WEBPACK FOOTER **
 ** ./src/Slide.js
 **/